<template>
  <!-- name: '发货地址' -->
  <div class="infoAddressWrap">
    <van-loading v-if="isLazyLoad" />
    <van-loading v-show="isShowLoading">加载中...</van-loading>
    <div class="listBox" v-show="!isShowLoading">
      <div class="emptyBox" v-if="addressList.length < 1">
        <img src="https://img.bbalt.cn/imgh5/userCenter/img_empty.png" alt="" />
        <button
          class="addBtn"
          @click="
            $router.push({
              path: '/userCenterThird',
              query: {
                title: '新建发货地址',
                nextPath: '/userInfo',
                curSelectTab: '发货地址',
              },
            })
          "
        >
          快来添加常规地址吧～
        </button>
      </div>
      <ul v-else>
        <li v-for="(item, index) in addressList" :key="index">
          <span v-show="item.isDefault === 1" class="defaultBox">默认</span>
          <div class="infoBaseClass">
            <img
              src="https://img.bbalt.cn/imgh5/userCenter/icon_location.svg"
              alt=""
            />
            <div class="textClass" @click="hanldRightAddress(item)">
              <span class="nameClass">{{ item.contacts }}</span
              >&nbsp;<span>{{ item.phone }}</span>
            </div>

            <img
              src="https://img.bbalt.cn/imgh5/userCenter/icon_edit.svg"
              alt=""
              class="editImg"
              @click="
                $router.push({
                  path: '/userCenterThird',
                  query: {
                    title: '修改发货地址',
                    objData: item,
                    nextPath: '/userInfo',
                    curSelectTab: '发货地址',
                  },
                })
              "
            />
          </div>
          <p>
            {{ item.provinceName }}{{ item.cityName }}{{ item.districtName
            }}{{ item.address }}
          </p>
        </li>
      </ul>
    </div>
    <button
      class="addBtn"
      @click="
        $router.push({
          path: '/userCenterThird',
          query: {
            title: '新建发货地址',
            nextPath: '/userInfo',
            curSelectTab: '发货地址',
          },
        })
      "
    >
      添加常规地址
    </button>
  </div>
</template>

<script>
import { myAddressList } from "@/api/userCenter";
import mixin from "@/utils/mixin.js";
export default {
  mixins: [mixin],
  components: {},
  data() {
    return {
      addressList: [],
      listQuery: { pageNo: 1, pageSize: 10 },
      total: 0,
      isShowLoading: true,
      isLazyLoad: false,
    };
  },
  created() {
    this.getMyAddressList();
  },
  methods: {
    hanldRightAddress(item) {

      if (this.$route.query.nextPath === "/send") {
        this.$router.push({
          path: "/send",
          query: {
            curStep: "预约取件",
            curStepIndex: 3,
            sendInfo: JSON.stringify(item),
            donateInfoId: this.$route.query.donateInfoId,
          },
        });
      }
    },
    async getMyAddressList(pageNo, isLazy) {
      if (isLazy) {
        this.isLazyLoad = true;
      }
      this.listQuery.pageNo = pageNo > 1 ? pageNo : this.listQuery.pageNo;
      const { content } = await myAddressList(this.listQuery);

      this.addressList = isLazy
        ? [...this.addressList, ...content.records]
        : content.records;
      this.total = content.total;
      this.isShowLoading = false;
      this.isLazyLoad = false;
    },
  },
  mounted() {
    let dom = document.querySelector(".listBox");
    this.handleScrollLazy(
      dom,
      this.listQuery.pageNo,
      this.listQuery.pageSize,
      this.total,
      this.getMyAddressList
    );
  },
};
</script>

<style lang="scss" scoped>
.infoAddressWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
  font-family: PingFangSC, PingFang SC;
  display: flex;
  flex-flow: column;
  align-items: center;
  .emptyBox {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    img {
      width: 290px;
      height: 290px;
      margin-bottom: 39px;
      margin-top: 240px;
    }
  }
  .listBox {
    background-color: #fff;
    font-family: PingFangSC, PingFang SC;
    margin-bottom: 38px;
    max-height: 66%;
    overflow: auto;
    ul {
      padding: 48px 0px 32px 32px;

      li {
        max-height: 212px;
        padding: 15px 0px;
        display: flex;
        flex-flow: column;
        justify-content: center;
        border-bottom: 1px solid #ededed;
        .defaultBox {
          background: rgba(103, 159, 210, 0.08);
          border-radius: 4px;
          display: inline-block;
          font-size: 22px;
          font-weight: 400;
          color: #679fd2;
          line-height: 30px;
          margin-bottom: 18px;
          margin-left: 56px;
          width: 56px;
          text-align: center;
        }
        .infoBaseClass {
          font-size: 30px;
          font-weight: 600;
          color: #333333;
          margin-bottom: 8px;
          display: flex;
          justify-content: space-between;
          .textClass {
            width: 560px;
            .nameClass {
              max-width: 320px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
            }
          }
        }
        p {
          font-size: 26px;
          font-weight: 400;
          color: #666666;
          margin-left: 56px;
          width: 580px;
        }
        &:last-child {
          border: none;
        }
        img {
          width: 30px;
          height: 30px;
          margin-right: 26px;
        }
        .infoBox {
          margin-left: 26px;
          width: 580px;
        }
        .editImg {
          margin-right: 32px;
          margin-left: 56px;
        }
      }
    }
  }

  .addBtn {
    width: 560px;
    height: 88px;
    background: #fe66a6;
    border-radius: 47px;
    border: none;
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}

.van-loading {
  text-align: center;
  margin: 10px 0px;
}
</style>
